import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Common/Modal/Modal';
import DatePicker from '../../Common/DatePicker/DatePicker';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';

export default class OpeningDateModal extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            openingDate: Moment.utc(new Date()).format(DATE_FORMAT)
        }
    }

    onChange = (date, name) => {
        this.setState({ [name]: date });
    }

    onComplete = () => {
        this.props.onComplete(this.state.openingDate);
    }

    renderBody = () => {

        return (
            <div>
                <div>Please select an Opening/Zero Date so we can preview your Baseline Tasks properly in the Gantt Chart. You can change this later.</div>
                <div className="mt-3 mb-3">
                    <DatePicker
                        showIcon
                        value={this.state.openingDate}
                        name="openingDate"
                        label="Opening/Zero Date"
                        onChange={this.onChange}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <Modal
                id="selectOpeningDate"
                title="Select Opening/Zero Date"
                body={this.renderBody()}
                onCloseClick={this.props.onCancel}
                onPrimaryClick={this.onComplete}
                onSecondaryClick={this.props.onCancel}
            />
        );
    }

}

OpeningDateModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};